import React, { useState, useEffect, useCallback } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import BlogCard from "../component/BlogCard";

const BlogSlider = ({ blogPosts }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const totalCards = blogPosts.length;
  const autoSlideInterval = 3000; // 3 seconds

  // ✅ Responsive visible cards
  const getVisibleCount = () => {
    if (window.innerWidth < 640) return 1; // mobile
    if (window.innerWidth < 1024) return 2; // tablet
    return 3; // desktop
  };

  const [visibleCards, setVisibleCards] = useState(getVisibleCount());

  useEffect(() => {
    const handleResize = () => setVisibleCards(getVisibleCount());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Fix ESLint warning with useCallback
  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalCards);
  }, [totalCards]);

  const prevSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalCards) % totalCards);
  }, [totalCards]);

  // ✅ Auto slide effect (pause on hover)
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      nextSlide();
    }, autoSlideInterval);
    return () => clearInterval(interval);
  }, [nextSlide, isPaused, autoSlideInterval]);

  const getVisibleCards = () => {
    const visible = [];
    for (let i = 0; i < visibleCards; i++) {
      visible.push(blogPosts[(currentIndex + i) % totalCards]);
    }
    return visible;
  };

  return (
    <div
      className="relative w-full overflow-hidden"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {/* Cards Wrapper */}
      <div className="flex justify-center items-center gap-4 transition-all duration-500 ease-in-out">
        {getVisibleCards().map((post) => (
          <div
            key={post.id}
            className="flex-shrink-0 w-[300px] sm:w-[360px] md:w-[360px] h-[500px] bg-white rounded-lg shadow-md"
          >
            <BlogCard {...post} />
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-3 top-1/2 transform -translate-y-1/2 bg-gray-300 text-white p-2 rounded-full hover:bg-gray-700 z-10"
      >
        <FaArrowLeft />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-gray-300 text-white p-2 rounded-full hover:bg-gray-700 z-10"
      >
        <FaArrowRight />
      </button>
    </div>
  );
};

export default BlogSlider;
